<input
  [ngStyle]="{
    width: '100%',
    fontFamily: initOptions.fontFamily,
    fontSize: initOptions.fontSize + 'px',
    textAlign: initOptions.textAlign,
    height: initOptions.height + 'px',
  }"
  [ngModel]="initOptions.value"
  class="{{ initOptions.style }}"
  type="text" />
